module.exports = __webpack_public_path__ + "img/sSoccerK_193x205.2b5be271.png";